// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container___S4MuV {
    width: 25vw;
    height: 12.5vw;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.style__titleContainer___ziGgH {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--black);
    width: 100%
}

.style__title___Slg1O {
    font-size: 16px;
    font-weight: 500;
    padding: 8px;
    color: #fff;
}

.style__buttonsContainer___a1KJ4 {
    display: flex;
    flex-direction: row;
    margin-top: 2vw;
    width: 15vw;
    justify-content: space-between;
}

.style__button___PacZm {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 5vw;
    font-size: 15px;
    border-radius: 40px;
    height: 32px;
    margin: auto;
    border: 1px solid var(--black);
    margin-bottom: 16px;
    text-align: center;
    color: var(--black);
}
`, "",{"version":3,"sources":["webpack://./src/components/Modals/InputModal/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":[".container {\n    width: 25vw;\n    height: 12.5vw;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.titleContainer {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--black);\n    width: 100%\n}\n\n.title {\n    font-size: 16px;\n    font-weight: 500;\n    padding: 8px;\n    color: #fff;\n}\n\n.buttonsContainer {\n    display: flex;\n    flex-direction: row;\n    margin-top: 2vw;\n    width: 15vw;\n    justify-content: space-between;\n}\n\n.button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 5vw;\n    font-size: 15px;\n    border-radius: 40px;\n    height: 32px;\n    margin: auto;\n    border: 1px solid var(--black);\n    margin-bottom: 16px;\n    text-align: center;\n    color: var(--black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container___S4MuV`,
	"titleContainer": `style__titleContainer___ziGgH`,
	"title": `style__title___Slg1O`,
	"buttonsContainer": `style__buttonsContainer___a1KJ4`,
	"button": `style__button___PacZm`
};
export default ___CSS_LOADER_EXPORT___;
